import InspireRomanWoff from 'url:../fonts/InspireTWDC-Roman.woff';
import InspireRomanWoff2 from 'url:../fonts/InspireTWDC-Roman.woff2';
import InspireRomanEot from 'url:../fonts/InspireTWDC-Roman.eot';
import InspireMediumWoff from 'url:../fonts/InspireTWDC-Medium.woff';
import InspireMediumWoff2 from 'url:../fonts/InspireTWDC-Medium.woff2';
import InspireMediumEot from 'url:../fonts/InspireTWDC-Medium.eot';
import InspireHeavyWoff from 'url:../fonts/InspireTWDC-Heavy.woff';
import InspireHeavyWoff2 from 'url:../fonts/InspireTWDC-Heavy.woff2';
import InspireHeavyEot from 'url:../fonts/InspireTWDC-Heavy.eot';
import InspireBlackWoff from 'url:../fonts/InspireTWDC-Black.woff';
import InspireBlackWoff2 from 'url:../fonts/InspireTWDC-Heavy.woff2';
import InspireBlackEot from 'url:../fonts/InspireTWDC-Black.eot';

export const inspire = `
  @font-face {
    font-family: "Inspire";
    font-style: normal;
    font-weight: 400;
    src: url(${InspireRomanEot}) format('eot');
    src:
      url(${InspireRomanWoff2}) format('woff2'),
      url(${InspireRomanWoff}) format('woff');
  }`;

export const inspireMed = `
  @font-face {
    font-family: "Inspire";
    font-style: normal;
    font-weight: 500;
    src: url(${InspireMediumEot}) format('eot');
    src:
      url(${InspireMediumWoff2}) format('woff2'),
      url(${InspireMediumWoff}) format('woff');
  }`;

export const inspireHeavy = `
  @font-face {
    font-family: "Inspire";
    font-style: normal;
    font-weight: 700;
    src: url(${InspireHeavyEot}) format('eot');
    src:
      url(${InspireHeavyWoff2}) format('woff2'),
      url(${InspireHeavyWoff}) format('woff');
  }`;

export const inspireBlack = `
  @font-face {
    font-family: "Inspire";
    font-style: normal;
    font-weight: 800;
    src: url(${InspireBlackEot}) format('eot');
    src:
      url(${InspireBlackWoff2}) format('woff2'),
      url(${InspireBlackWoff}) format('woff');
  }`;
